<template>
  <ChatBody :domain="domain" type-call="MEETING" />
  <ChatDmFooter v-if="state.isVisibleDm" />
  <ChatFooter v-show="!state.isVisibleDm" :domain="domain" type-call="MEETING" :list-button-visible="footerOptions" />
</template>

<script setup lang="ts">
import ChatBody from '@/components/domains/chat/common/ChatBody.vue';
import ChatDmFooter from '@/components/domains/chat/common/ChatDmFooter.vue';
import ChatFooter from '@/components/domains/chat/common/ChatFooter.vue';
import { useAudioStore } from '@/stores/audio';
import { useMicrophoneStore } from '@/stores/microphone';
import { useUserStore } from '@/stores/user';
import { TypeDomain } from '@/types/common';
import { ChatFooterOptions, ChatFooterViewType } from '@/types/components';
import { DEFAULT_CHAT_UI_STATE, CHAT_FOOTER_PRESETS } from '@/utils/constants/chat';
import { DOMAIN } from '@/utils/constants/common';
import { ij_chat_ui } from '@/utils/injectionKeys';

withDefaults(
  defineProps<{
    code: string;
  }>(),
  {
    code: '',
  }
);

const audioStore = useAudioStore();
const userStore = useUserStore();
const microphoneStore = useMicrophoneStore();

const { state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE); // provide: ChatLayout

const route = useRoute();

const domain = computed<TypeDomain>(() => {
  const metaDomain = route.meta.domain;
  return metaDomain && Object.values(DOMAIN).includes(metaDomain) ? metaDomain : 'CHAT';
});

const footerViewType = computed<ChatFooterViewType>(() => {
  if (state.isVisibleMCSPController) return 'MCSP';
  if (state.isVisibleMCSController) return 'MCS';
  return 'MEETING';
});

const footerOptions = computed<ChatFooterOptions[]>(() => {
  return CHAT_FOOTER_PRESETS[footerViewType.value] || [];
});

onMounted(() => {
  const levelSize = userStore.isTablet ? 5 : 3;
  userStore.setTextMultiplier(levelSize);
});

onUnmounted(() => {
  userStore.setTextMultiplier(0);
});

watch(
  () => [audioStore.isMutedByEmployee, microphoneStore.isMicOn],
  async (val) => {
    if (val[0] && val[1]) {
      await microphoneStore.stopMic();
    }
  }
);
</script>

<style lang="scss" scoped></style>
